import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { Common } from '../../utils/common';
import EmployeeSelect from '../reporting_utils/EmployeeSelect';

class RepresentativeCode extends HTMLElement {
  connectedCallback() {
    this.innerHTML = `<div id="representative_dropdown"></div>`;

    const employeeName = /** @type {string} */ (this.getAttribute('employee_name'));
    const callId = /** @type {string} */ (this.getAttribute('aicallid'));
    const staticCallId = /** @type {string} */ (this.getAttribute('static_call_id'));
    const domainId = /** @type {string} */ (this.getAttribute('domain_id'));

    ReactDOM.render(
      React.createElement(RepresentativeDropdown, {
        employeeName,
        callId,
        staticCallId,
        domainId,
        updateRowData: this.updateRowData.bind(this),
      }),
      this.querySelector('#representative_dropdown')
    );
  }

  /**
   * @this {RepresentativeCode}
   * @param {string} employeeName
   */
  updateRowData(employeeName) {
    const table = $('.table').DataTable();
    const rowData = table.row(this.closest('tr')).data();
    rowData.employeename = employeeName;
    table.row(this.closest('tr')).invalidate().draw();
  }
}

customElements.define('representative-code', RepresentativeCode);

/**
 * @param {{
 *   employeeName: string;
 *   callId: string;
 *   staticCallId: string;
 *   domainId: string;
 *   updateRowData: (employeeName: string) => void;
 * }} props
 */
function RepresentativeDropdown({ employeeName, callId, staticCallId, domainId, updateRowData }) {
  const [isEditing, setIsEditing] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedRepresentative, setSelectedRepresentative] = useState(
    employeeName === 'null' || employeeName.trim() === ''
      ? null
      : { value: '', label: employeeName }
  );

  /** @type {string | null} */
  let call_id = null;
  if (callId !== 'null') {
    call_id = callId;
  }

  /** @type {string | null} */
  let static_call_id = null;
  if (staticCallId !== 'null') {
    static_call_id = staticCallId;
  }

  async function handleRepresentativeChange(newValue) {
    setSelectedRepresentative(newValue);
    setIsLoading(true);
    try {
      const res = await fetch('/reports/representative', {
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name=csrf-token]').content,
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify({
          call_id: call_id,
          static_call_id: static_call_id,
          user_id: newValue.value,
        }),
      });
      if (!res.ok) {
        throw res;
      }
      const employeeName = newValue.label.split(' (')[0];
      updateRowData(employeeName);
      Common.notify('Representative successfully updated', 'success');
    } catch (error) {
      console.error(error);
      Common.notify('Failed to update representative', 'error');
    } finally {
      setIsLoading(false);
      setIsEditing(false);
    }
  }

  if (isEditing) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <EmployeeSelect
          onChange={handleRepresentativeChange}
          locationIds={[Number(domainId)]}
          groupIds={[]}
          value={selectedRepresentative}
          isLoading={isLoading}
        />
        <span
          role='button'
          onClick={() => {
            setIsEditing(false);
          }}
          className='glyphiconno glyphicon-remove'
        />
      </div>
    );
  } else {
    return (
      <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
        <span style={{ paddingRight: 12 }}>{employeeName === 'null' ? '' : employeeName}</span>
        <span
          role='button'
          onClick={() => setIsEditing(true)}
          style={{ position: 'absolute', right: 0 }}
          className='fa fa-male'
        />
      </div>
    );
  }
}
